import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllItensServicoEmpreendimentoUseCase } from "../../../presentation/useCases/read/get_all_itens_servico_empreendimento_use_case";
import { ItemServicoEmpreendimento } from "../../models/item_servico_empreendimento";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * GetAllItensServicoEmpreendimentoUseCase
 */

export class GetAllItensServicoEmpreendimentoUseCase extends BasePaginatedUseCase<ItemServicoEmpreendimento>
  implements IGetAllItensServicoEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { super(); }

  async getAllItensServicoEmpreendimento(
    idChecklistServicoEmpreendimento?: number,
    idsChecklistServico?: number[],
    idsBloco?: number[],
    idsUnidade?: number[],
    idsItemServicoEmpreendimento?: number[],

    page?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const response = await this.repository.getAllItensServicoEmpreendimento(
      idChecklistServicoEmpreendimento,
      idsChecklistServico,
      idsBloco,
      idsUnidade,
      idsItemServicoEmpreendimento,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;

  }
}
